import { UsuarioService } from '../../../services/usuario.service';
import { Component, computed, effect, ElementRef, HostListener, inject, OnInit, signal, ViewChild } from '@angular/core';
import { SidebarService, NavigationGroup } from '../../../services/sidebar.service';
import { environment } from '../../../../environments/environment';
import { House, Leaf, Droplets, LayoutDashboard, Users, ClipboardList, Truck, HandCoins, ChartNoAxesCombined, ListChecks, Settings, Bell, Plug, FileSignature, FileSpreadsheet, Search, ChevronRight, PanelLeftClose, PanelLeftOpen, X, Database, Route, Settings2, SlidersHorizontal } from 'lucide-angular';

@Component({
  selector: 'app-sidebar', templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'], standalone: false,
})
export class SidebarComponent implements OnInit {
  readonly sidebarService = inject(SidebarService);
  private readonly users = inject(UsuarioService);
  openMobile(event: Event): void { this.sidebarService.openMobile(event.currentTarget as HTMLElement); }
  closePanels(): void {}
  readonly appVersion = environment.appVersion;
  readonly query = signal('');
  readonly icons: Record<string, any> = { home: House, eco: Leaf, uco: Droplets, dashboard: LayoutDashboard,
    clients: Users, orders: ClipboardList, routes: Route, collection: Truck, commissions: HandCoins,
    reports: ChartNoAxesCombined, benefits: ListChecks, settings: Settings, notifications: Bell,
    integrations: Plug, signatures: FileSignature, 'eco-import': FileSpreadsheet, 'data-maintenance': Database, search: Search, chevron: ChevronRight,
    // Settings entries: one distinct icon each (docs/ui-ux/settings-nuevos-componentes/analysis-v1.0.md, UX-007).
    selects: Settings2, 'eco-settings': SlidersHorizontal,
    collapse: PanelLeftClose, expand: PanelLeftOpen, close: X };
  readonly visibleGroups = computed(() => {
    const query = this.query().trim().toLowerCase();
    return this.sidebarService.groups().map(group => ({ ...group,
      submenu: group.submenu.filter(item => !query || `${group.titulo} ${item.titulo}`.toLowerCase().includes(query))
    })).filter(group => group.submenu.length);
  });
  @ViewChild('panel') panel?: ElementRef<HTMLElement>;
  constructor() {
    effect(() => {
      if (this.sidebarService.mobileOpen()) {
        queueMicrotask(() => this.panel?.nativeElement.querySelector<HTMLElement>('[data-mobile-close]')?.focus());
      } else { this.closePanels(); }
    });
    effect(() => {
      this.sidebarService.currentUrl(); this.users.usuario;
      this.closePanels();
    });
  }
  ngOnInit(): void { this.sidebarService.cargarMenu(); this.sidebarService.revealActiveGroup(); }
  expanded(group: NavigationGroup): boolean { return !!this.query().trim() || this.sidebarService.isExpanded(group.id); }
  @HostListener('window:resize') onResize(): void {
    if (window.innerWidth >= 1280) this.sidebarService.closeMobile(false);
  }
  @HostListener('document:keydown', ['$event']) onKeydown(event: KeyboardEvent): void {
    if (!this.sidebarService.mobileOpen()) return;
    if (event.key === 'Escape') { event.preventDefault(); this.sidebarService.closeMobile(); }
    if (event.key !== 'Tab') return;
    const elements = Array.from(this.panel?.nativeElement.querySelectorAll<HTMLElement>('a[href],button,input') || [])
      .filter(element => element.getClientRects().length && !element.hasAttribute('disabled'));
    const first = elements[0], last = elements[elements.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  }
}
